/* eslint-disable semi */
/* eslint-disable comma-dangle */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import baseurl from '../../../../@core/auth/jwt/baseurl'

export const getAllCaseTypes = createAsyncThunk('appChooseCaseType/getAllCaseTypes', async () => {
  const secondChoose = JSON.parse(localStorage.getItem('CachedSecondCaseTypeChoose'))
  const firstChoose = JSON.parse(localStorage.getItem('CachedFirstCaseTypeChoose'))

  const response = await baseurl.get('/api/app/case-type/lookup-list', {
    params: {
      isParant: true,
      isActive: true,
      maxResultCount: 100,
      isReregister: secondChoose === 3,
      caseTypeRelation: secondChoose === 2 ? secondChoose : firstChoose,
      isChangeInfo: secondChoose === 4
    }
  })
  return {
    data: response.data.items,
    totalPages: response.data.totalCount
  }
})

export const removeAllCaseTypes = createAsyncThunk('appChooseCaseType/getAllCaseTypes', async () => {

  return {
    data: [],
    totalPages: 0
  }
})

export const appChooseCaseType = createSlice({
  name: 'appChooseCaseType',
  initialState: {
    data: [],
    total: 1,
    loading: true
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllCaseTypes.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.loading = false
    })
  }
})

export default appChooseCaseType.reducer